import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 80 80"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.543 74.099C.618 62.896-5.643 38.47 5.56 19.545 16.761.618 41.187-5.643 60.113 5.559c18.927 11.204 25.188 35.63 13.985 54.555-11.202 18.925-35.626 25.188-54.555 13.985Zm38.883-21.396a1.408 1.408 0 0 0 0-1.99L47.297 39.585l9.189-4.785c.501-.263.798-.799.753-1.362a1.41 1.41 0 0 0-.963-1.223L24.383 21.708a1.406 1.406 0 0 0-1.777 1.777l10.507 31.893a1.407 1.407 0 0 0 2.584.21l4.786-9.189 11.128 11.129c.549.55 1.44.55 1.99 0l4.825-4.825Z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon_desktop"}) } }